import { CommonModule } from '@angular/common';
import { Component, input, OnChanges, output, signal } from '@angular/core';
import { isArray } from 'lodash-es';

@Component({
  imports: [CommonModule],
  selector: 'context-message',
  templateUrl: './context-message.component.html',
  styleUrls: ['./context-message.component.scss'],
})
export class ContextMessage implements OnChanges {
  message = input<string | string[]>([]);
  messageType = input<MessageType>(MessageType.info);
  dismiss = output<void>();

  public messageLines = signal<string[]>([]);

  ngOnChanges(event: any): void {
    if (event.message && this.message()) {
      this.messageLines.set(isArray(this.message()) ? (this.message() as string[]) : [this.message() as string]);
    }
  }

  dismissMessage(): void {
    this.dismiss.emit();
  }
}

export const enum MessageType {
  error = 'error',
  info = 'info',
  warning = 'warning',
  success = 'success',
}
